module.exports = __webpack_public_path__ + "wave-bg.svg?eaa62771df666994876973972cb8cfab";